import SearchIcon from "@mui/icons-material/Search";
// import { Token, useToken } from "@/entities";
// import { LastUsedToken, TokenName, useLastUsedTokens } from "@/features";
import { Box, Button, Stack, TextField, Typography } from "@mui/material";
import { ethers } from "ethers";
import { bridgeTokenConfig } from "modules/bridge/config";
import { useCallback, useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { useAccount } from "wagmi";
import { Address } from "viem";

type TokenSelectProps = {
  onSelect: (address: Address, chainId: number) => void;
};

export const TokenSelect = ({ onSelect }: TokenSelectProps) => {
  const { watch } = useFormContext();
  const { chainIdFrom, chainIdTo } = watch();
  const { chainId } = useAccount();

  const onSubmit = (address: Address, chainId: number) => {
    // addToken(chainId, address);
    onSelect(address, chainId);
  };

  const [filteredTokens, setFilteredTokens] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  const onSearchInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(event.target.value.trim());
  };

  const onSearch = useCallback(() => {
    if (!searchQuery) {
      setFilteredTokens([]);
      return;
    }

    setFilteredTokens([]);
  }, [searchQuery]);

  const customToken = {
    symbol: "N/A",
    address: "",
  };

  useEffect(() => {
    onSearch();
  }, [searchQuery, onSearch]);

  const tokens = bridgeTokenConfig[
    chainIdFrom as keyof typeof bridgeTokenConfig
  ].filter((token) =>
    token?.networksTo.length
      ? token.networksTo.includes(chainIdTo)
      : chainIdTo === 1 || chainIdTo === 227
  );

  return (
    <Stack spacing={2}>
      <Box position="relative">
        <TextField
          placeholder="Search name or paste address"
          variant="outlined"
          fullWidth
          onChange={onSearchInput}
          InputProps={{
            startAdornment: <SearchIcon />,
          }}
        />
      </Box>

      {/*{!searchQuery && (*/}
      {/*  <Stack direction="row" spacing={1} flexWrap="wrap">*/}
      {/*    {popularTokenList.map(({ address, name, symbol }) => (*/}
      {/*      <Button*/}
      {/*        key={address}*/}
      {/*        variant="outlined"*/}
      {/*        onClick={() => {*/}
      {/*          if (chainId) {*/}
      {/*            onSubmit(address, chainId);*/}
      {/*          }*/}
      {/*        }}*/}
      {/*      >*/}
      {/*        <Stack>{symbol}</Stack>*/}
      {/*      </Button>*/}
      {/*    ))}*/}
      {/*  </Stack>*/}
      {/*)}*/}

      <Stack
        border="1px solid"
        borderColor="grey.200"
        padding={3}
        borderRadius={2}
      >
        <Typography variant="highlight" color="text.secondary">
          {searchQuery ? "Search results" : "Popular tokens"}
        </Typography>

        <Stack spacing={1} marginTop={2}>
          {tokens.map(
            ({ address, chainId, name, symbol, logoURI, networksTo }) => (
              <Button
                key={`${address}_${symbol}_${chainId}_${networksTo.join(",")}`}
                onClick={() => onSubmit(address as Address, chainId)}
                variant="text"
                fullWidth
                sx={{ justifyContent: "flex-start" }}
              >
                <Stack direction="row" gap={5} alignItems="center">
                  <img
                    style={{
                      width: "36px",
                      height: "36px",
                      borderRadius: "50%",
                      background: "white",
                    }}
                    src={logoURI}
                  />
                  <Stack gap={0} alignItems="start">
                    <Typography variant="highlight">{name}</Typography>
                    <Typography variant="body2">{symbol}</Typography>
                  </Stack>
                </Stack>
              </Button>
            )
          )}
        </Stack>
      </Stack>

      {searchQuery && filteredTokens.length === 0 && (
        <Box>
          {customToken.symbol !== "N/A" ? (
            <Button
              onClick={() => {
                if (chainId) {
                  onSubmit(customToken.address as Address, chainId);
                }
              }}
              variant="text"
              fullWidth
              sx={{ justifyContent: "flex-start" }}
            >
              {/*<TokenName*/}
              {/*  address={customToken.address}*/}
              {/*  chainId={chainId}*/}
              {/*  showName*/}
              {/*/>*/}
            </Button>
          ) : (
            <Typography color="textSecondary">No results</Typography>
          )}
        </Box>
      )}
    </Stack>
  );
};
